export default __webpack_public_path__ + "static/media/how_to_choose_the_perfect_yacht_for_your_holiday_at_sea.d94e1017.webp";